import { Component, Input, OnInit } from '@angular/core';
import { SummaryStageDto } from '../../data/CommandServiceDtos.generated';

@Component({
  standalone: false,
  selector: 'project-cxplanner-stage',
  templateUrl: './project-cxplanner-stage.component.html',
  styleUrls: ['./project-cxplanner-stage.component.scss'],
})
export class ProjectCxplannerStageComponent implements OnInit {
  @Input() stage: SummaryStageDto;

  constructor() { }

  ngOnInit() {
  }

}
